import type { ReactNode } from 'react';
import { Outlet } from 'react-router-dom';
import { BottomNav } from './BottomNav';

/** Standard screen chrome: skip link, scrollable main, bottom navigation. */
export function AppShell() {
  return (
    <div className="flex min-h-dvh flex-col">
      <a href="#main" className="skip-link">
        Skip to content
      </a>
      <div className="flex-1 pb-24">
        <Outlet />
      </div>
      <BottomNav />
    </div>
  );
}

export function Screen({ children }: { children: ReactNode }) {
  return (
    <main id="main" className="safe-x mx-auto flex max-w-2xl flex-col gap-4 px-4 pb-6">
      {children}
    </main>
  );
}

/** Full-bleed layout for rehearsal, which hides the nav to stay one-handed. */
export function FocusScreen({ children }: { children: ReactNode }) {
  return (
    <main id="main" className="safe-x safe-bottom flex min-h-dvh flex-col">
      {children}
    </main>
  );
}
